import React from 'react';
import moment from 'moment';

const KpiReferenceMonth = () => {
  return (
    <span>
      Reference month for the indicators:
      <strong> {moment().subtract(1, 'months').format('MMMM')}</strong>
    </span>
  );
};

export default KpiReferenceMonth;
